export default {
  namespaced: true,
  state: {
    root: {
      account_suspended: false,
      payment_mark_as_paid: false,
      payment_bank_transfer: false,
      custom_link: false,
      store_features: false,
      lead_remarks: false,
      e_commerce_integrations: false,
      subscribe_cms: false,
      subscribe_appointment: false,
      subscribe_review: false,
      subscribe_purchase_hub: false,
      subscribe_marketing: false,
    },
    side_menu: {
      '/admin/books-reminders': false,
      '/admin/yezza-book': false
    },
    page_permissions: {
      '/admin/analytics': {
        enter: false,
        components: {
          product_ranking: false,
          sales_team_ranking: false
        }
      },
      '/admin/dashboard': {
        enter: true,
        components: {
          statistics: false,
          books_quick_action: false,
          sales_chart: false,
          agent_sales_chart: false,
          profit_chart: false,
          unpaid_invoices: false,
          quick_links: false,
          referral_program: false
        }
      },
      '/admin/products': {
        enter: true,
        components: {
          max_order_quantity: false
        }
      },
      '/admin/orders': {
        enter: false
      },
      '/admin/orders-new': {
        enter: false
      },
      '/admin/database': {
        enter: false,
        components: {
          view_history: false
        }
      },
      '/admin/sales-team': {
        enter: false
      },
      '/admin/forms': {
        enter: false
      },
      '/admin/yezza-store': {
        enter: false,
        components: {
          settings: false
        }
      },
      '/admin/offers': {
        enter: false,
        components: {
          product_bundle: false
        }
      },
      '/admin/settings/shipping': {
        enter: false,
        components: {
          self_pickup: false,
          cash_on_delivery: false
        }
      },
      '/admin/settings/shipping-new': {
        enter: false
      },
      '/admin/settings/order-settings': {
        enter: false
      },
      '/admin/settings/advance': {
        enter: false,
        components: {
          payment_gateway: false
        }
      },
      '/admin/settings/advance-new': {
        enter: false
      },
      '/admin/yezza-book/incomes': {
        enter: false
      },
      '/admin/yezza-book/expenses': {
        enter: false
      },
      '/admin/yezza-book/reports': {
        enter: false
      },
      '/admin/settings/books': {
        enter: false
      },
      '/admin/settings/checkout': {
        enter: false,
        components: {
          pass_service_fee: false
        }
      },
      '/admin/follow-up': {
        enter: false,
        components: {
          follow_up_action: false
        }
      },
      '/admin/landing-pages': {
        enter: false,
        components: {
          landing_page_action: false
        }
      },
      '/admin/clinic/settings': {
        enter: false,
        components: {
          general: false,
          payment: false,
          analytics: false,
          integration: false,
          subscription: false,
          bills: false,
          delete_company: false
        }
      },
      '/admin/clinic/registration': {
        enter: false,
        components: {
          schedule: false,
        }
      },
      '/admin/clinic/appointment': {
        enter: false,
      },
      '/admin/clinic/consultation': {
        enter: false,
        components: {
          set_appointment: false,
        }
      },
      '/admin/clinic/insight': {
        enter: false,
      },
      '/admin/clinic/review': {
        enter: false,
      },
      '/admin/clinic/review-settings': {
        enter: false,
      },
      '/admin/clinic/users': {
        enter: false,
      },
      '/admin/clinic/user-logs': {
        enter: false,
      },
      '/admin/clinic/reports/sales': {
        enter: false,
        components: {
          view_sales_report: false,
        }
      },
      '/admin/clinic/purchase-hub': {
        enter: false,
      },
      '/admin/clinic/marketing': {
        enter: false,
      },
      '/admin/clinic/settings/marketing': {
        enter: false,
      },
      '/admin/clinic/panels/claims': {
        enter: false,
      },
    }
  },
  mutations: {
    setPermissions(state, permissions) {
      state.root = permissions.root
      state.side_menu = permissions.side_menu
      state.page_permissions = permissions.page_permissions
    }
  },
  getters: {
    getPagePermissions(state) {
      return state.page_permissions
    }
  }
}
